module.exports = __webpack_public_path__ + "img/011-toilet-paper.719eaae0.svg";